import { OnInit, EventEmitter } from '@angular/core';
import { NotificationService } from './notification.service';
var NotificationComponent = /** @class */ (function () {
    function NotificationComponent(notificationService) {
        this.notificationService = notificationService;
        this.items = [
            {
                id: 'tabNoLeidas',
                label: 'No Leídas'
            },
            {
                id: 'tabLeidas',
                label: 'Leídas'
            }
        ];
        this.notifications = new Array();
        this.isLoading = false;
        this.onHandleCloseNotification = new EventEmitter();
    }
    NotificationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isLoading = true;
        this.notificationService.getNotificationsByStatus(false).subscribe(function (notificationsData) {
            _this.notifications = notificationsData;
        }).add(function () { _this.isLoading = false; });
    };
    NotificationComponent.prototype.actionNotificationClick = function (notification) {
        var _this = this;
        this.notificationService.setStatusNotifications(notification.id, !notification.isRead).subscribe(function () {
            _this.notificationService.getNotificationsByStatus(notification.isRead).subscribe(function (notificationsData) {
                _this.notifications = notificationsData;
            }).add(function () { _this.isLoading = false; });
        });
    };
    NotificationComponent.prototype.selectTab = function (selectedTab) {
        var _this = this;
        var status = (selectedTab.id === 'tabNoLeidas') ? false : true;
        this.isLoading = true;
        this.notificationService.getNotificationsByStatus(status).subscribe(function (notificationsData) {
            _this.notifications = notificationsData;
        }).add(function () { _this.isLoading = false; });
    };
    NotificationComponent.prototype.readAndClose = function (notification) {
        if (!notification.isRead) {
            this.actionNotificationClick(notification);
        }
        this.closeNotification();
    };
    NotificationComponent.prototype.closeNotification = function () {
        this.onHandleCloseNotification.emit();
    };
    NotificationComponent.prototype.getTitleCard = function (notification) {
        return this.notificationService.getNotificationTitleCard(notification);
    };
    NotificationComponent.prototype.getActionsCard = function (notification) {
        return this.notificationService.getNotificationTypeAction(notification);
    };
    NotificationComponent.prototype.getReason = function (notification) {
        var reason;
        if (notification.notificationTypeId === 'CANCELACION_POLIZA' || notification.notificationTypeId === 'RECHAZO_UW') {
            reason = notification.data.CancellationReason;
        }
        return reason;
    };
    NotificationComponent.prototype.getTransitoryPaymentRequestCount = function (notification) {
        return notification.notificationTypeId === 'RECHAZO_PAGO' ? notification.data.transitoryRejectedCount : null;
    };
    NotificationComponent.prototype.getDefinitivePaymentRequestCount = function (notification) {
        return notification.notificationTypeId === 'RECHAZO_PAGO' ? notification.data.definitiveRejectedCount : null;
    };
    return NotificationComponent;
}());
export { NotificationComponent };
